import { Timeframes } from "@/components/widgets/Chart/types";
import type { FiscalPeriod } from "@/components/widgets/Financials/types";
import type { AuthColor, ViewId } from "../types/common";

export const WIDGETS_WITH_TICKERS_LIST: ViewId[] = ["Monitor", "Screener"];

export const DEFAULT_GRID_PAGE_SIZE = 200;

export const DEFAULT_MAX_PAGE_SIZE = 10000;

export const DEFAULT_TICKER = "AAPL";

export const DEFAULT_STATE_VALUES = {
	ticker: "",
	fiscalPeriod: "QTR" as FiscalPeriod,
	timeFrame: Timeframes.ONE_DAY,
};

export const CHART_COLORS = {
	RED: "#cc3300",
	GREEN: "#339933",
	GOLD: "#d5b972",
	BLUE: "#0962e7",
	GRAY: "#4d4e50",
};

export const authTextColor: Record<AuthColor, string> = {
	bronze: "text-bronze",
	silver: "text-silver",
	gold: "text-gold",
	platinum: "text-platinum",
};

export const authGradients: Record<AuthColor, string> = {
	bronze: "to-bronze",
	silver: "to-[#666565]",
	gold: "to-gold",
	platinum: "to-white",
};

export const Z_INDEX = {
	CUSTOM_MODAL_BACKGROUND: 100,
} as const;

export const SUPPORT_EMAIL = "support@epsmomentum.com" as const;

export const STRIPE_CHECKOUT_DOMAIN = ["checkout.stripe.com"];
